export default {
  rarity: {
    1: "#485767",
    2: "#099853",
    3: "#3FA4CD",
    4: "#E50DC2",
    5: "#DAAA29",
    6: "#2771DF",
    7: "#2771DF",
    8: "#2771DF",
    10: "#2771DF",
  },
  rarityGradient: {
    1: "linear-gradient(45deg, #2B4259 0%, #485767 100%)",
    2: "linear-gradient(45deg, #275E4E 0%, #099853 100%)",
    3: "linear-gradient(45deg, #3A4894 0%, #3FA4CD 100%)",
    4: "linear-gradient(45deg, #7A1C7E 0%, #E50DC2 100%)",
    5: "linear-gradient(45deg, #8B4D09 0%, #DAAA29 65%)",
    6: "linear-gradient(90deg, #43DEC2 0%, #2771DF 50%, #A430EB 100%)",
    7: "linear-gradient(90deg, #43DEC2 0%, #2771DF 50%, #A430EB 100%)",
    8: "linear-gradient(90deg, #43DEC2 0%, #2771DF 50%, #A430EB 100%)",
    10: "linear-gradient(90deg, #43DEC2 0%, #2771DF 50%, #A430EB 100%)",
  },
  placement: {
    gradient: {
      1: "linear-gradient(to top, #f5af3c, #f3ce8e)",
      2: "linear-gradient(to top, #ABB2B0, #D4D7D6)",
      3: "linear-gradient(to top, #8E6543, #C4A281)",
      4: "linear-gradient(to top, #4E5F73, #859AAB)",
      default: "#5b6885",
    },
    solid: {
      1: "#EEBD69",
      2: "#A6ACB9",
      3: "#AE8967",
      4: "#859AAB",
      default: "#5b6885",
    },
  },
  placementDistribution: {
    gradient: {
      1: "linear-gradient(0deg, #D69C3C 0%, #F5C776 100%)",
      2: "linear-gradient(360deg, #ABB2B0 0%, #D4D7D6 100%)",
      3: "linear-gradient(0deg, #8E6543 0%, #C4A281 100%)",
      4: "linear-gradient(0deg, #4E5F73 0%, #859AAB 100%)",
      default: "#4C5873",
    },
    solid: {
      1: "#EEBD69",
      2: "#CBCFCE",
      3: "#AE8967",
      4: "#859AAB",
      default: "#4C5873",
    },
  },
  probuilds: {
    gradients: {
      1: "linear-gradient(to left, rgba(238, 189, 105, 0) 0%, #eebd69 100%)",
      2: "linear-gradient(to left, var(--shade8) 0%, rgba(24, 35, 56, 0.71) 100%)",
    },
  },
  spacing(value) {
    try {
      return 8 * Number(value);
    } catch {
      return 0;
    }
  },
};
